import { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const HalleImpressum = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Header />
      
      <section className="py-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-5xl font-bold text-gray-900 mb-12 text-center" data-testid="halle-impressum-title">
            Impressum Halle
          </h1>
          
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 prose prose-lg max-w-none">
            <h2>Informationspflicht laut § 5 TMG</h2>
            <p>
              <strong>Ambulante Pflege Großstadtherzen® Halle UG</strong><br />
              Merseburger Str. 19<br />
              06112 Halle (Saale)<br />
              Deutschland
            </p>
            <p>
              Tel.: <a href="tel:034568669465">0345-68669465</a><br />
              Fax: 0345-68669469<br />
              E-Mail: <a href="mailto:info@grossstadtherzen-halle.de">info@grossstadtherzen-halle.de</a>
            </p>

            <h3>Aufsichtsbehörde</h3>
            <p>Der Landesbeauftragte für den Datenschutz Sachsen-Anhalt</p>
            <p>
              Webseite der Aufsichtsbehörde:<br />
              <a href="https://datenschutz.sachsen-anhalt.de" target="_blank" rel="noopener noreferrer">https://datenschutz.sachsen-anhalt.de</a>
            </p>
            <p>
              <strong>Anschrift der Aufsichtsbehörde</strong><br />
              Leiterstraße 9, 39104 Magdeburg
            </p>
            <p>
              <strong>Berufsbezeichnung:</strong> Ambulanter Pflegedienst
            </p>

            <h2>EU-Streitschlichtung</h2>
            <p>
              Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten (ODR-Verordnung) möchten wir Sie über die Online-Streitbeilegungsplattform (OS-Plattform) informieren.
            </p>
            <p>
              Verbraucher haben die Möglichkeit, Beschwerden an die Online Streitbeilegungsplattform der Europäischen Kommission unter <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=DE" target="_blank" rel="noopener noreferrer">http://ec.europa.eu/odr</a> zu richten.
            </p>
            <p>
              Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder verpflichtet sind, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>

            <h2>Haftung für Inhalte dieser Website</h2>
            <p>
              Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns korrekte und aktuelle Informationen bereitzustellen. Laut Telemediengesetz (TMG) §7 (1) sind wir als Diensteanbieter für eigene Informationen, die wir zur Nutzung bereitstellen, nach den allgemeinen Gesetzen verantwortlich.
            </p>
            <p>
              Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitten wir Sie uns umgehend zu kontaktieren, damit wir die rechtswidrigen Inhalte entfernen können.
            </p>

            <h2>Haftung für Links auf dieser Website</h2>
            <p>
              Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir nicht verantwortlich sind. Haftung für verlinkte Websites besteht für uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten hatten und haben.
            </p>

            <h2>Urheberrechtshinweis</h2>
            <p>
              Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht der Bundesrepublik Deutschland. Bitte fragen Sie uns bevor Sie die Inhalte dieser Website verbreiten, vervielfältigen oder verwerten.
            </p>

            <h2>Bildernachweis</h2>
            <p>
              Die Bilder, Fotos und Grafiken auf dieser Webseite sind urheberrechtlich geschützt.
            </p>
            <p>
              Die Bilderrechte liegen bei:
            </p>
            <ul>
              <li>Ambulante Pflege Großstadtherzen® UG</li>
              <li>Unsplash.com (lizenzfreie Bilder)</li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HalleImpressum;
